import {BRANCH_LEVEL} from "../../xpresso/src/routes/common/logic/user-level";

export const myListingsEnabled = ({company, session, userLevels}) => company?.prefs && userLevels.userLevel ? (
    !company?.prefs?.enableMyListing ? (
        userLevels.userLevel !== BRANCH_LEVEL || session?.data?.branch?.enableMyListing !== 1 ? (
            false
        ) : (
            true
        )
    ) : (
        userLevels.userLevel === BRANCH_LEVEL && session?.data?.branch?.enableMyListing === 0 ? (
            false
        ) : (
            true
        )

    )
) : true;
